import React, { useEffect, useState, ReactElement } from 'react';
import { DistributorDataContext, IDistributorDataTypeState, IFAQItems } from 'context/DistributorData';
import {
    SCPageWrapper,
    SCContentWrapper,
    SCEyebrow,
    SCSectionWrapper,
    SCFooterWrapper,
    SCContentDirectionWrapper,
    SCContentSectionResponsiveWrapper
} from 'styles/global-styles';
import { Accordion } from 'components/molecules/Accordion';
import { IFAQProps } from './types';
import { GlobalFooter } from 'components/organisms/GlobalFooter';
import { FlexAlignItemsEnum, FlexDirectionEnum } from 'enums/StyleTypes';

const FAQ = ({ children }: IFAQProps): ReactElement => {
    const { contextStateDistributorData, updateContextStateDistributorData } = React.useContext(
        DistributorDataContext
    ) as IDistributorDataTypeState;
    const [faqGeneral, setFAQGeneral] = useState<IFAQItems[]>();
    useEffect(() => {
        if (contextStateDistributorData?.client_content) {
            setFAQGeneral(contextStateDistributorData.client_content.faq_collections);
        }
    }, [contextStateDistributorData]);
    return (
        <>
            <SCPageWrapper>
                <SCContentWrapper>
                    <SCContentDirectionWrapper
                        flexDirection={FlexDirectionEnum.COLUMN}
                        flexAlignment={FlexAlignItemsEnum.FLEX_START}
                    >
                        <SCContentSectionResponsiveWrapper
                            flexDirection={FlexDirectionEnum.COLUMN}
                            flexAlignment={FlexAlignItemsEnum.FLEX_START}
                            flexGap={'24px'}
                        >
                            <SCEyebrow>Frequently Asked Questions</SCEyebrow>
                            {faqGeneral &&
                                faqGeneral.map((data: IFAQItems, index) => {
                                    return (
                                        <SCSectionWrapper key={`faq_item_${index}`}>
                                            <Accordion
                                                data={data.group_list}
                                                group_label={`${data.group_label}`}
                                            ></Accordion>
                                        </SCSectionWrapper>
                                    );
                                })}
                        </SCContentSectionResponsiveWrapper>
                    </SCContentDirectionWrapper>
                </SCContentWrapper>
                <SCFooterWrapper>
                    <GlobalFooter />
                </SCFooterWrapper>
            </SCPageWrapper>
        </>
    );
};

export { FAQ };
